import script from "./authorizationModal.vue?vue&type=script&lang=jsx&setup=true"
export * from "./authorizationModal.vue?vue&type=script&lang=jsx&setup=true"

import "./authorizationModal.vue?vue&type=style&index=0&id=d36bc344&lang=less"

const __exports__ = script;

export default __exports__